import { api } from './BaseApi'
import {
  ITaskObjectCreateDto,
  ITaskObjectCreateResponseDto,
} from './dto/TaskDto'

export const taskApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createTaskObject: builder.mutation<
      ITaskObjectCreateResponseDto,
      ITaskObjectCreateDto
    >({
      query: (body) => ({
        method: 'POST',
        url: '/employee_tasks/task_objects/',
        body,
      }),
      invalidatesTags: ['Task'],
    }),
  }),
})

export const { useCreateTaskObjectMutation } = taskApi
